import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import styles from '../41e3e4ef74b344163f6f9c634823f771533dce8ee2dfa33ad6af214c7fd67517.cfe-internal.js';
import SearchIcon from '../../../icons/components/1495732e5461e51c1abd3f9cddd936eda29b30ef1ae28b457233daad3614b8cb.cfe-internal.js';
import Input from '../../Input/577c254e00ce56943ccab46348a1c6ad5bda145d45157ec99bf0af8e4422d8ca.cfe-internal.js';
import useTranslation from '../../../utils/Translation/47d395f30036b487ef3ded6d813eeb8887878947654c2f6624000c7005c4dd94.cfe-internal.js';

var MenuSearchBox = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var rest = _extends({}, _ref);

  var _useTranslation = useTranslation(),
      translate = _useTranslation.translate;

  var searchText = translate('searchText');
  return /*#__PURE__*/React__default.createElement("div", {
    className: styles.searchBox
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    className: styles.searchBoxIcon,
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement(Input, _extends({
    ref: ref,
    role: "searchbox",
    "aria-label": searchText,
    placeholder: searchText,
    className: styles.searchBoxInput,
    full: true
  }, rest)));
});
var MenuSearchBox$1 = MenuSearchBox;

export { MenuSearchBox$1 as default };
